class VideoSwitcher extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');

    if (this.video) {
      this.bindVideoSwitcher();
    }
  }

  bindVideoSwitcher() {
    const landscapeQuery = window.matchMedia('(min-width: 1025px)');

    function handleViewportChange(mql) {
      this.video.load();
      requestAnimationFrame(() => {
        this.video.play();
      });
    }

    handleViewportChange.bind(this)(landscapeQuery);
    landscapeQuery.addEventListener('change', handleViewportChange.bind(this));
  }
}

customElements.define('video-switcher', VideoSwitcher);
